import axios from 'axios'
import { getBaseUrl } from '../../utils'

export const getCommonTexts = (lng: string) => {
  const baseUrl = getBaseUrl(lng)

  return axios.get(`${baseUrl}/api/v1/explanatory_texts`).then((response) => response.data)
}
